<template>
  <div>
    <div class="columns">
      <div class="map">
        <gmap-map
          :center="centerReseaux"
          :zoom="zoomCartoReseaux"
          :options="mapOptions"
          class="googleMap"
          ref="map"
          @zoom_changed="updateZoom($event)"
          @click="close()">
          <app-info-window-map-faces
            v-bind:centre="center"
            v-bind:marker="selectedMarkerFacesDeReseaux"
            @closeInfoWindow="selectedMarkerFacesDeReseaux=''"/>
          <div v-if="zoomCartoReseaux >= 12">
            <gmap-marker
              :key="m.num"
              v-for="(m) in markersFacesParReseaux"
              :position="m.position"
              :clickable="m.clickable"
              :draggable="false"
              :icon="m.icon"
              @click="center=m.position, updateSelectedMarkerFaces(m),
              isComponentDetailFacesReseauxTempo = true;">
            </gmap-marker>
          </div>
          <div v-else>
            <gmap-marker
              :key="'R' + index"
              v-for="(m, index) in markersReseaux"
              :position="m.position"
              :clickable="m.clickable"
              :draggable="false"
              :icon="m.icon"
              @click="center=m.position, updateSelectedMarkerReseaux(m),
              isComponentDetailReseauxTempo = true">
            </gmap-marker>
            <gmap-marker
              v-for="(point, i) in getPointsAddress"
              :key="i+point.libelle"
              :position="point.coordonnees"
              :clickable="point.clickable"
              :draggable="false"
              :icon="point.icon"
              @click="center=point.coordonnees, updateSelectedMarkerReseaux(point),
              isComponentDetailReseauxTempo = true">
            </gmap-marker>
          </div>
          <gmap-marker
            v-for="concurrent in concurrentsFiltres"
            :key="concurrent.id"
            :position="concurrent.position"
            :clickable="false"
            :draggable="false"
            :icon="concurrent.icone">
          </gmap-marker>
          <gmap-marker
            key="test"
            :position="getCenterReseaux"
            :clickable="false"
            :zIndex="zIndexCenter"
            :draggable="false"
            :icon=puceNoire>
          </gmap-marker>
        </gmap-map>
      </div>
      <b-modal
        v-model="isComponentDetailReseauxTempo"
        has-modal-card
        class="modal">
        <app-info-window-map-reseaux
          :centre="center"
          :marker="selectedMarkerReseaux"
          :nbFacesRestantes="nbFacesRestantes"
          :dataProposition="dataProposition"
          @zoomReseau="zoomReseau(selectedMarkerReseaux, 0)"/>
      </b-modal>
      <b-modal
        v-model="isComponentDetailFacesReseauxTempo"
        has-modal-card
        class="modal">
        <app-info-window-map-faces
          :centre="center"
          :marker="selectedMarkerFacesDeReseaux"/>
      </b-modal>
    </div>
    <app-statistiques-geo-marketing
      :address="getCenterReseaux"
      :isochrone="isochrone"
      :typeLayerGeoMarketing="typeLayerGeoMarketing" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { setTimeout } from 'timers';
import moment from 'moment';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import { getMapGeoJson } from '@/api/asterop';
import { getConcurrents, overrideStyle } from '@/services/asterop/mapHelper';
import statistiquesGeoMarketing from '@/components/general/statistiquesGeoMarketing';
import { MINIMUM_CLUSTER_SIZE, TYPE_LAYER_EMPTY, MARKER_POINT_NOIR,
  TYPE_LAYER_GEO_MARKETING_CONCU, STYLE_MAPS_POI_HIDDEN,
  MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';
import { getPropositions } from '@/api/reseaux';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import InfoWindowMapFaces from '@/components/creationOpportunite/cartographie/infoWindowMapFaces';
import InfoWindowMapReseaux from './cartographie/infoWindowMapReseaux';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const User = createNamespacedHelpers('user');
const Parametrage = createNamespacedHelpers('parametrage');

export default {
  name: 'app-map',
  data() {
    return {
      center: '',
      minClusterSize: MINIMUM_CLUSTER_SIZE,
      nbFacesRestantes: null,
      dataProposition: {},
      isComponentDetailReseauxTempo: false,
      isComponentDetailFacesReseauxTempo: false,
      layerGeoMarketting: false,
      concurrents: [],
      zIndexCenter: 9999,
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  watch: {
    async activeTabReseau() {
      await this.autoZoom();
    },
    async isochrone() {
      await this.updateLayer();
    },
    async getCenterReseaux() {
      await this.updateLayer();
    },
    async typeLayerGeoMarketing() {
      await this.updateLayer();
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      markersReseaux: 'markersReseaux',
      markersFacesParReseaux: 'markersFacesParReseaux',
      getZoomCartoReseaux: 'zoomCartoReseaux',
      getCenterReseaux: 'centerReseaux',
      isochrone: 'isochrone',
      typeLayerGeoMarketing: 'typeLayerGeoMarketing',
      getSelectedMarkerFacesDeReseaux: 'selectedMarkerFacesDeReseaux',
      getSelectedMarkerReseaux: 'selectedMarkerReseaux',
      activeTabReseau: 'activeTabReseau',
      getPointsAddress: 'pointsAddress',
    }),
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    ...Parametrage.mapGetters({
      symboles: 'symboles',
    }),
    puceNoire() {
      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'urlLogo')) {
        const h = 40;
        let w = h;
        const img = new Image();
        img.src = this.getCenterReseaux.urlLogo;
        if (img.height > 0) {
          w = img.width / (img.height / h);
        }
        const icon = {
          url: this.getCenterReseaux.urlLogo,
          scaledSize: { width: w, height: h, f: 'px', b: 'px' },
        };
        return icon;
      }

      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'symbole') &&
          this.symboles &&
          Object.prototype.hasOwnProperty.call(this.symboles, this.getCenterReseaux.symbole)) {
        const icon = {
          url: this.symboles[this.getCenterReseaux.symbole],
          size: { width: 50, height: 50, f: 'px', b: 'px' },
          scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
        };
        return icon;
      }
      // Si le fait que le marker peut être noir qq secondes avant d'être remplacé par
      // le logo il est possible de rendre ce bout de code plus intelligent
      // et mettre en premier lieu un markeur transparent
      // 'data:image/gif;base64,R0lGODlhAQABAIAAAP'
      return MARKER_POINT_NOIR;
    },
    concurrentsFiltres() {
      if (Object.prototype.hasOwnProperty.call(this.getCenterReseaux, 'codeType')) {
        const tmp = this.concurrents.filter(c =>
          c.codeType === this.getCenterReseaux.codeType && c.icone);
        tmp.forEach((element) => {
          element.icone = {
            url: element.icone,
            size: { width: 20, height: 20, f: 'px', b: 'px' },
            scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
          };
        });
        return tmp;
      }
      this.concurrents.forEach((element) => {
        element.icone = {
          url: element.icone,
          size: { width: 20, height: 20, f: 'px', b: 'px' },
          scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
        };
      });
      return this.concurrents;
    },
    zoomCartoReseaux: {
      get() {
        return this.getZoomCartoReseaux;
      },
      set(value) {
        this.setZoomCartoReseaux(value);
      },
    },
    centerReseaux: {
      get() {
        return this.getCenterReseaux;
      },
      set(value) {
        this.setCenterReseaux(value);
      },
    },
    selectedMarkerFacesDeReseaux: {
      get() {
        return this.getSelectedMarkerFacesDeReseaux;
      },
      set(value) {
        this.setSelectedMarkerFacesDeReseaux(value);
      },
    },
    selectedMarkerReseaux: {
      get() {
        return this.getSelectedMarkerReseaux;
      },
      set(value) {
        this.setSelectedMarkerReseaux(value);
      },
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setZoomCartoReseaux: types.SET_ZOOM_CARTO_RESEAUX,
      setCenterReseaux: types.SET_CENTER_RESEAUX,
      setSelectedMarkerFacesDeReseaux: types.SET_SELECTED_MARKER_FACES_DE_RESEAUX,
      setSelectedMarkerReseaux: types.SET_SELECTED_MARKER_RESEAUX,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...Parametrage.mapActions({
      actionsLoadSymboles: 'loadSymboles',
    }),
    ...VenteReseauxTempo.mapActions({
      updateMarkerReseau: 'updateMarkerReseau',
    }),
    updateZoom($event) {
      this.zoomCartoReseaux = $event;
    },
    updateSelectedMarkerReseaux(marker) {
      const dateStart = moment(this.getDateDeVisualisation);
      const dateEnd = dateStart.clone().add(6, 'days');
      const semaine = moment(this.dateDeVisualisation).isoWeek();
      const annee = moment(this.dateDeVisualisation).isoWeekYear();
      const libelle = getAnneeSemaine(annee, semaine);
      const num = [marker.reseaux[0].num];
      getPropositions(dateStart.format('YYYYMMDD'), dateEnd.format('YYYYMMDD'), num).then((response) => {
        if (response.data[num] && response.data[num][libelle]) {
          this.dataProposition = response.data[num][libelle];
          this.nbFacesRestantes = this.dataProposition.facesPrevues -
            this.dataProposition.quantiteVendue;
        }
        this.selectedMarkerReseaux = marker;
      });
    },
    updateSelectedMarkerFaces(marker) {
      this.selectedMarkerFacesDeReseaux = marker;
    },
    close() {
      if (this.selectedMarkerReseaux) {
        this.selectedMarkerReseaux = '';
      }
      if (this.selectedMarkerFacesDeReseaux) {
        this.selectedMarkerFacesDeReseaux = '';
      }
    },
    zoomReseau(marker, timeout) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      new Promise(resolve => {
        this.centerReseaux = marker.position;
        setTimeout(resolve, timeout);
      }).then(() => {
        loadingComponent.close();
        this.zoomCartoReseaux = 12;
      });
    },
    async updateLayer() {
      // Largement inspiré de
      // https://stackoverflow.com/questions/50496101/remove-google-map-geojson-polygon
      // https://developers.google.com/maps/documentation/javascript/datalayer
      const map = await this.$refs.map.$mapPromise;
      this.concurrents = [];
      if (this.layerGeoMarketting && this.layerGeoMarketting.setMap) {
        this.layerGeoMarketting.setMap(null);
      }
      if (!this.getCenterReseaux ||
          !this.hasGeoMarketing ||
          this.typeLayerGeoMarketing === TYPE_LAYER_EMPTY) {
        return;
      }
      this.layerGeoMarketting = new google.maps.Data({
        map: map,
      });

      const response = await getMapGeoJson(this.typeLayerGeoMarketing, this.centerReseaux,
        this.isochrone);
      if (this.typeLayerGeoMarketing === TYPE_LAYER_GEO_MARKETING_CONCU) {
        this.concurrents = await getConcurrents(this.centerReseaux,
          this.isochrone, 1, this.symboles);
      }
      const geoJson = response.data;
      const styles = geoJson.style;

      this.layerGeoMarketting.addGeoJson(geoJson);
      this.layerGeoMarketting.setStyle((feature) => {
        return overrideStyle(feature, styles);
      });
    },
    async autoZoom() {
      await this.$refs.map.$mapPromise;
      await this.fitBounds();
    },
    async fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      if (this.markersFacesParReseaux.length) {
        this.markersFacesParReseaux.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.markersReseaux.length) {
        this.markersReseaux.forEach(marker => {
          latlngbounds.extend(marker.position);
        });
      }
      if (this.getPointsAddress.length) {
        this.getPointsAddress.forEach(marker => {
          latlngbounds.extend(marker.coordonnees);
        });
      }
      latlngbounds.extend(this.centerReseaux);
      await this.$refs.map.fitBounds(latlngbounds);
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
      map.setMapTypeId('styled_map');
    },
  },
  async mounted() {
    await this.autoZoom();
    await this.initPoi();
    this.updateMarkerReseau();
    if (this.hasGeoMarketing) {
      await this.updateLayer();
      await this.actionsLoadSymboles();
    }
  },
  components: {
    appInfoWindowMapFaces: InfoWindowMapFaces,
    appInfoWindowMapReseaux: InfoWindowMapReseaux,
    appStatistiquesGeoMarketing: statistiquesGeoMarketing,
  },
};

</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/carte.vue